module.exports = __webpack_public_path__ + "img/t_0009.58714358.gif";